interface SkeletonProps {
  width?: string;
  height?: string;
  rounded?: 'sm' | 'md' | 'lg' | 'full' | 'none';
  circle?: number;
  className?: string;
}

const roundedMap = {
  none: 'rounded-none',
  sm: 'rounded-xs',
  md: 'rounded-md',
  lg: 'rounded-lg',
  full: 'rounded-full',
} as const;

export function Skeleton({ width, height = 'h-4', rounded = 'md', circle, className = '' }: SkeletonProps) {
  if (circle) {
    return (
      <div
        className={`animate-pulse rounded-full bg-brand-neutral-200 dark:bg-brand-neutral-700 ${className}`}
        style={{ width: circle, height: circle }}
      />
    );
  }

  return (
    <div
      className={`animate-pulse bg-brand-neutral-200 dark:bg-brand-neutral-700 ${roundedMap[rounded]} ${height} ${width ?? ''} ${className}`}
    />
  );
}
